export default __webpack_public_path__ + "static/media/playlists_group.ab6e6e19.svg";